import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1C1917] text-stone-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <span className="font-display text-2xl font-semibold text-white">qr<span className="text-[#D4AF37] italic">cupid</span></span>
          <p className="text-sm text-stone-400 mt-4 leading-relaxed max-w-xs">Your profile, one scan away. An invitation-worthy way to make real-world connections.</p>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#D4AF37] mb-4">Product</h4>
          <ul className="space-y-3 text-sm text-stone-400">
            <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
            <li><Link to="/register" className="hover:text-white transition-colors">Join Free</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Log In</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#D4AF37] mb-4">Company</h4>
          <ul className="space-y-3 text-sm text-stone-400">
            <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#D4AF37] mb-4">Legal</h4>
          <ul className="space-y-3 text-sm text-stone-400">
            <li>Privacy (GDPR)</li>
            <li>Terms of Service</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-stone-500">
        © 2026 qrcupid. Crafted for real-world romance.
      </div>
    </footer>
  );
}
